<template>
  <div 
    class="xit-fb-template node"
    @dblclick.stop="handleClick(node)" 
    :class="[camelCase(node.name), hasData(node), isSelected(node), 'node-id-' + node.id]" 
  >
    <div class="title">
      <p class="title-content"><i class="fas fa-walking card-start-icon"></i> {{node.lingualName}}</p>
    </div>

    <div class="card-body-handler card_data_body p-0">
      

      <div class="card-data">
        <div v-if="node.data.title">
          <p class="text-center mb-2 postback_title" v-if="node.data.title">
            {{node.data.title}}
          </p>
  
          <div class="list-group mt-2" v-if="node.data.title && node.data.postbackId">
            <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"  v-if="node.data.triggerKeyword">   
              <small class="text-muted">{{ trigger_html_info_keywords_short }}</small>
              <p class="mb-0"> {{ node.data.triggerKeyword }}</p>
            </span>
            <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"  v-if="node.data.triggerKeyword">   
              <small class="text-muted">{{ trigger_html_matching_type_short }}</small>
              <p class="mb-0"> {{ node.data.triggerMatchingType=='exact' ? trigger_html_exact_match : trigger_html_string_match }}</p>
            </span>
            <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"  v-if="getSelectedLabelTexts(node)">   
              <small class="text-muted">{{ button_html_add_label }}</small>
              <p class="mb-0"> {{ getSelectedLabelTexts(node) }}</p>
            </span>
            <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"  v-if="getSelectedRemoveLabelTexts(node)">   
              <small class="text-muted">{{ button_html_remove_label }}</small>
              <p class="mb-0"> {{ getSelectedRemoveLabelTexts(node) }}</p>
            </span>
            <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"  v-if="node.data.sequenceIdValue && node.data.sequenceIdText">   
              <small class="text-muted">{{ button_html_add_sequence }}</small>
              <p class="mb-0"> {{ node.data.sequenceIdText }}</p>
            </span>
            <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"  v-if="node.data.sequenceIdValueRemove && node.data.sequenceIdTextRemove">   
              <small class="text-muted">{{ button_html_remove_sequence }}</small>
              <p class="mb-0"> {{ node.data.sequenceIdTextRemove }}</p>
            </span>
            <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"  v-if="node.data.conversationGroupId && node.data.conversationGroupText">   
              <small class="text-muted">{{ button_html_conversation_group }}</small>
              <p class="mb-0"> {{ node.data.conversationGroupText }}</p>
            </span>
            <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"  v-if="node.data.conversationUserId && node.data.conversationUserText">   
              <small class="text-muted">{{ button_html_conversation_user }}</small>
              <p class="mb-0"> {{ node.data.conversationUserText }}</p>
            </span>
            <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"  v-if="node.data.buttonWebhookUrl && node.data.buttonWebhookUrl">   
              <small class="text-muted"><a>{{ button_html_label_webhook_url }}</a></small>
              <p class="mb-0">
                <a :href="node.data.buttonWebhookUrl" :title="node.data.buttonWebhookUrl" target="_BLANK">{{node.data.buttonWebhookUrl.length>40 ? node.data.buttonWebhookUrl.slice(0, 40)+'...' : node.data.buttonWebhookUrl}}...</a>
              </p>
            </span>
            <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"
              v-if="getSelectedGoogleSheets(node)">
              <small class="text-muted">{{ button_html_google_sheet_add }}</small>
              <p class="mb-0"> {{ getSelectedGoogleSheets(node) }}</p>
            </span>
          </div>
        </div>
        <div v-else class="tdouble-click-div text-center">
          <img :src="icon_doubletap" :title="double_click_for_settings">
        </div>

      </div>

      <div class="card-sockets">
        <div class="output_content">
          <div 
            class="output text-right" 
            :key="output.key" 
            :ref="(output.key === referenceOutputSequence) ? 'referenceOutputSequence' : ''"
            v-for="output in outputs()" 
            :class="[toggleSpecificSocket(node), hasConnection(output) ? 'has-connection' : '']"
          >
            <div class="output-title">{{output.name}}</div>
            <Socket v-socket:output="output" type="output" :socket="output.socket"></Socket>
          </div>
        </div>
        <div class="input_content"> 
          <div 
            class="input text-left" 
            v-for="input in inputs()" 
            :key="input.key" 
            :class="[hasConnection(input) ? 'has-connection' : 'd-none']"
          >
            <Socket v-socket:input="input" type="input" :socket="input.socket"></Socket>
            <div class="input-title">{{input.name}}</div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import VueRenderPlugin from 'rete-vue-render-plugin'
import { lang } from '../../assets/lang'

import CONST_SOCKET from '../../const/socket'
import { templateComponentMethods } from '../../utils/functions'

export default {
  name: 'ReferenceTemplate',
  mixins: [VueRenderPlugin.mixin],
  components: {
    Socket: VueRenderPlugin.Socket
  },

  data: () => ({
    referenceOutputSequence: CONST_SOCKET.REFERENCE_OUTPUT_SEQUENCE,
    otn_single_html_labels: lang.otn_single_html_labels,
    button_html_add_label: lang.button_html_add_label,
    button_html_remove_label: lang.button_html_remove_label,
    button_html_add_sequence: lang.button_html_add_sequence,
    button_html_remove_sequence: lang.button_html_remove_sequence,
    button_html_conversation_group: lang.button_html_conversation_group,
    button_html_conversation_user: lang.button_html_conversation_user,
    button_html_label_webhook_url: lang.button_html_label_webhook_url,
    postback_new_socket_output_sequence: lang.postback_new_socket_output_sequence,
    postback_new_html_label_title: lang.postback_new_html_label_title,
    trigger_html_info_keywords_short: lang.trigger_html_info_keywords_short,
    trigger_html_matching_type_short: lang.trigger_html_matching_type_short,
    trigger_html_exact_match: lang.trigger_html_exact_match,
    trigger_html_string_match: lang.trigger_html_string_match,
    double_click_for_settings: lang.double_click_for_settings,
    icon_doubletap: window.xitFlowBuilderData.icon_doubletap,
    button_html_google_sheet_add: button_html_google_sheet_add,
  }),

  methods: {
    ...templateComponentMethods,

    getSelectedLabelTexts(node) {
      const labelIdTextsArray = node.data.labelIdTextsArray || []
      return labelIdTextsArray.join(', ')
    },

    getSelectedRemoveLabelTexts(node) {
      const labelIdTextsArrayRemove = node.data.labelIdTextsArrayRemove || []
      return labelIdTextsArrayRemove.join(', ')
    },

    getSelectedGoogleSheets(node) {
      const googleSheetsArray = node.data.googleSheetsArray || []
      return googleSheetsArray.join(', ')
    },

    toggleSpecificSocket(node) {
      const element = $(this.$refs.referenceOutputSequence)
      if('newSequence' === node.data.sequenceIdValue) {
        element.removeClass('d-none').addClass('d-block')
      } else {
        element.removeClass('d-block').addClass('d-none')
        setTimeout(function() {
          element.removeClass('d-block').addClass('d-none')
        }, 100)
      }
    },

  },

  mounted() {
    const that = this
    this.$nextTick(function () {
      $(that.$refs.referenceOutputSequence).addClass('d-none')
    })
  }
}
</script>